export interface RecalProcessAndGenSubmitEntity {

    billToCompany: string | null,
    oldTariff?: string | null,
    newTariff?: string | null,
    idList: number[],


    [key: string]: string[] | string | boolean | number | number[] | Date | null | undefined
}

export const EMPTY_RECAL_PROCESS_AND_GEN_SUBMIT_ENTITY: RecalProcessAndGenSubmitEntity = {
    billToCompany: null,
    oldTariff: null,
    newTariff: null,
    idList: []
}